import { render } from "./rooms-table.vue?vue&type=template&id=53fa6441&scoped=true&lang=pug"
import script from "./rooms-table.vue?vue&type=script&lang=js"
export * from "./rooms-table.vue?vue&type=script&lang=js"

import "./rooms-table.vue?vue&type=style&index=0&id=53fa6441&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fa6441"]])

export default __exports__